import { useIsMobile } from "@/hooks/use-mobile";
import { useAppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";
import { AppointmentDetailsDesktop } from "@/components/calendar/AppointmentDetailsDesktop";
import { MobileAppointmentDetails } from "@/components/calendar/mobile/appointment/MobileAppointmentDetails";

interface AppointmentDetailsDialogProps {
  appointmentId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  startInEditMode?: boolean;
}

export function AppointmentDetailsDialog(props: AppointmentDetailsDialogProps) {
  const ctrl = useAppointmentDetailsController(props);
  const isMobile = useIsMobile();
  return (
    <>
      {isMobile ? (
        <MobileAppointmentDetails ctrl={ctrl} />
      ) : (
        <AppointmentDetailsDesktop ctrl={ctrl} />
      )}
    </>
  );
}
